export default __webpack_public_path__ + "static/media/Santosh-Kumar.e816f012.jpg";